<div class="min-h-screen py-8">
  <div class="max-w-4xl mx-auto px-4">

    <!-- Header -->
    <div class="mb-6 flex items-center gap-3">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goBack()">
        <i class="fas fa-arrow-left me-1"></i> Volver
      </button>
      <div>
        <h1 class="text-2xl font-bold text-gray-900 mb-0">
          <i class="fas fa-sliders-h text-blue-600 mr-2"></i> Preferencias
        </h1>
        <p class="text-sm text-gray-600 mb-0">Configura el comportamiento de la consola</p>
      </div>
    </div>

    <!-- Tabs -->
    <div class="border-b border-gray-200 mb-4">
      <nav class="flex -mb-px">
        <button (click)="activeTab = 'pagos'"
                class="px-4 py-2 text-sm font-medium border-b-2"
                [ngClass]="activeTab === 'pagos' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
          <i class="fas fa-money-bill-wave me-1"></i> Pagos
        </button>
      </nav>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Cargando...</span></div>
    </div>

    <!-- Tab: Pagos -->
    <div *ngIf="!loading && activeTab === 'pagos'">
      <div class="bg-white rounded-lg p-4 shadow-sm border border-gray-200">
        <div class="mb-3">
          <h2 class="text-lg font-semibold text-gray-900 mb-1">Vista de pagos por defecto</h2>
          <p class="text-sm text-gray-600 mb-0">
            Define qué vista verán los usuarios al abrir los pagos de un cliente.
            Esta elección se aplica para todos; los usuarios no podrán cambiarla manualmente.
          </p>
        </div>

        <div class="row g-3">
          <!-- Opción: Tabla (nueva) -->
          <div class="col-12 col-md-6">
            <div class="ppref-option h-100 p-3 rounded border"
                 [class.ppref-selected]="defaultPaymentsView === 'tabla'"
                 [class.ppref-disabled]="!canConfig"
                 (click)="setPaymentsView('tabla')">
              <div class="d-flex align-items-start gap-2">
                <i class="fas fa-table fa-lg text-blue-600 mt-1"></i>
                <div class="flex-grow-1">
                  <div class="fw-bold text-gray-900">Tabla (nueva)</div>
                  <div class="small text-gray-600">Lista paginada con filtros, acciones rápidas y detalle en modal.</div>
                </div>
                <i class="fas fa-check-circle text-blue-600" *ngIf="defaultPaymentsView === 'tabla'"></i>
              </div>
            </div>
          </div>

          <!-- Opción: Clásica -->
          <div class="col-12 col-md-6">
            <div class="ppref-option h-100 p-3 rounded border"
                 [class.ppref-selected]="defaultPaymentsView === 'classic'"
                 [class.ppref-disabled]="!canConfig"
                 (click)="setPaymentsView('classic')">
              <div class="d-flex align-items-start gap-2">
                <i class="fas fa-id-card fa-lg text-blue-600 mt-1"></i>
                <div class="flex-grow-1">
                  <div class="fw-bold text-gray-900">Clásica</div>
                  <div class="small text-gray-600">Vista actual con tarjetas detalladas por pago.</div>
                </div>
                <i class="fas fa-check-circle text-blue-600" *ngIf="defaultPaymentsView === 'classic'"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3 small text-muted" *ngIf="saving">
          <i class="fas fa-spinner fa-spin me-1"></i> Guardando...
        </div>

        <div class="mt-3 small text-muted" *ngIf="!canConfig">
          <i class="fas fa-lock me-1"></i> No tienes permiso para modificar esta preferencia.
        </div>
      </div>

      <!-- Vista de pagos de Finanzas -->
      <div class="bg-white rounded-lg p-4 shadow-sm border border-gray-200 mt-4">
        <div class="mb-3">
          <h2 class="text-lg font-semibold text-gray-900 mb-1">Vista de pagos de Finanzas</h2>
          <p class="text-sm text-gray-600 mb-0">
            Define qué vista verán los usuarios al abrir Finanzas &gt; Pagos.
            Es independiente de la vista de pagos por cliente: si una falla, puedes usar la otra.
          </p>
        </div>

        <div class="row g-3">
          <!-- Opción: Tabla (nueva) -->
          <div class="col-12 col-md-6">
            <div class="ppref-option h-100 p-3 rounded border"
                 [class.ppref-selected]="defaultFinancePaymentsView === 'tabla'"
                 [class.ppref-disabled]="!canConfig"
                 (click)="setFinancePaymentsView('tabla')">
              <div class="d-flex align-items-start gap-2">
                <i class="fas fa-table fa-lg text-blue-600 mt-1"></i>
                <div class="flex-grow-1">
                  <div class="fw-bold text-gray-900">Tabla (nueva)</div>
                  <div class="small text-gray-600">Lista paginada con filtros, acciones rápidas y detalle en modal.</div>
                </div>
                <i class="fas fa-check-circle text-blue-600" *ngIf="defaultFinancePaymentsView === 'tabla'"></i>
              </div>
            </div>
          </div>

          <!-- Opción: Clásica -->
          <div class="col-12 col-md-6">
            <div class="ppref-option h-100 p-3 rounded border"
                 [class.ppref-selected]="defaultFinancePaymentsView === 'classic'"
                 [class.ppref-disabled]="!canConfig"
                 (click)="setFinancePaymentsView('classic')">
              <div class="d-flex align-items-start gap-2">
                <i class="fas fa-list fa-lg text-blue-600 mt-1"></i>
                <div class="flex-grow-1">
                  <div class="fw-bold text-gray-900">Clásica</div>
                  <div class="small text-gray-600">Vista actual con tarjetas detalladas por pago.</div>
                </div>
                <i class="fas fa-check-circle text-blue-600" *ngIf="defaultFinancePaymentsView === 'classic'"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3 small text-muted" *ngIf="savingFinance">
          <i class="fas fa-spinner fa-spin me-1"></i> Guardando...
        </div>

        <div class="mt-3 small text-muted" *ngIf="!canConfig">
          <i class="fas fa-lock me-1"></i> No tienes permiso para modificar esta preferencia.
        </div>
      </div>
    </div>

  </div>
</div>
